<template>
  <v-card>
    <v-card-title>{{ content }}</v-card-title>
    <v-progress-linear indeterminate />
  </v-card>
</template>

<script>
export default {
  name: 'loader-view',
  props: {
    content: {
      type: String,
      default: 'Please wait...',
    },
  },
};
</script>

<style></style>
